import {AfterViewInit, Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {ProductPriceLevelReportModel} from "./product-price-level-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-product-price-level-report-page",
    templateUrl: "./product-price-level-report-page.component.html",
    providers: [provideReportModel(ProductPriceLevelReportModel)]
})
export class ProductPriceLevelReportPageComponent extends AbstractReportPage implements AfterViewInit {

    constructor(public model: ProductPriceLevelReportModel) {
        super();
    }

    ngAfterViewInit(): void {
        if (this.reportParams) {
            this.model.data.priceLevels.push(this.reportParams);
        }
    }

}
